import startCase from 'lodash/startCase';

const STEPPER_KEY_TO_TRACKING_EVENT_NAME: Record<string, string> = {
    'scorp-election': 'S Corp Election',
    'itr-step-wizard': 'ITR Purchase',
    'individual-tax-organizer': 'ITR Organizer',
    'btr-organizer': 'BTR Organizer',
    'btr-review': 'BTR Review',
};

export const getDisplayFlowName = (key: string) => STEPPER_KEY_TO_TRACKING_EVENT_NAME[key] ?? startCase(key);
